export default "<div toast-component></div>\n";